const actionTypes = require('constants/actionTypes');
const Immutable = require('immutable');

const initialState = () => Immutable.fromJS({
    success: false,
    inProgress: false,
    error: ''
});

const BrokerOrderCancelReducer = (state = initialState(), action) => {
    switch (action.type) {
        case actionTypes.BROKER_ORDERS_AND_MOVEMENTS_CANCEL_VERIFY_REQUEST:
            return state.merge({
                inProgress: true
            });
        case actionTypes.BROKER_ORDERS_AND_MOVEMENTS_CANCEL_VERIFY_SUCCESS:
            return state;
        case actionTypes.BROKER_ORDERS_AND_MOVEMENTS_CANCEL_REQUEST:
            return state;
        case actionTypes.BROKER_ORDERS_AND_MOVEMENTS_CANCEL_SUCCESS:
            return state.merge({
                inProgress: false,
                success: true
            });
        case actionTypes.BROKER_ORDERS_AND_MOVEMENTS_CANCEL_VERIFY_FAILURE:
        case actionTypes.BROKER_ORDERS_AND_MOVEMENTS_CANCEL_FAILURE:
            return state.merge({
                inProgress: false,
                error: action.payload.error
            });
        case actionTypes.BROKER_ORDERS_AND_MOVEMENTS_CANCEL_CLEAR:
            return initialState();
        default:
            return state;
    }
}

module.exports = BrokerOrderCancelReducer;